module.exports = __webpack_public_path__ + "assets/img/7f3d-vg.svg";